module.exports = __webpack_public_path__ + "static/media/pose_flat.4c07280e.png";